module.exports = {
      id: "icon-facebook-usage",
      viewBox: "0 0 13.521 25.459",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#icon-facebook",
      toString: function () {
        return this.url;
      }
    }